import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import MealTooltip from './MealTooltip';
import ActivityTooltip from './ActivityTooltip';
import HbA1CTooltip from './HbA1CTooltip';
import PillTooltip from './PillTooltip';
import InjectionTooltip from './InjectionTooltip';
import NoteTooltip from './NoteTooltip';
import styles from './RelatedData.pcss';
const RelatedData = ({ element })=>{
    useStyles(styles);
    const elementType = element.resourceType || element.type;
    let relatedDataTooltip;
    switch(elementType){
        case 'Meal':
        case 'food':
            relatedDataTooltip = /*#__PURE__*/ _jsx(MealTooltip, {
                element: element
            });
            break;
        case 'Activity':
        case 'activity':
            relatedDataTooltip = /*#__PURE__*/ _jsx(ActivityTooltip, {
                element: element
            });
            break;
        case 'HbA1C':
            relatedDataTooltip = /*#__PURE__*/ _jsx(HbA1CTooltip, {
                element: element
            });
            break;
        case 'Medication':
            if (element.bolusFlag || element.basalFlag) {
                relatedDataTooltip = /*#__PURE__*/ _jsx(InjectionTooltip, {
                    element: element
                });
            } else {
                relatedDataTooltip = /*#__PURE__*/ _jsx(PillTooltip, {
                    element: element
                });
            }
            break;
        case 'Note':
            relatedDataTooltip = /*#__PURE__*/ _jsx(NoteTooltip, {
                element: element
            });
            break;
        case 'pill':
            relatedDataTooltip = /*#__PURE__*/ _jsx(PillTooltip, {
                element: element
            });
            break;
        case 'injection':
            relatedDataTooltip = /*#__PURE__*/ _jsx(InjectionTooltip, {
                element: element
            });
            break;
        default:
            relatedDataTooltip = null;
    }
    return /*#__PURE__*/ _jsx("div", {
        children: relatedDataTooltip
    });
};
export default /*#__PURE__*/ memo(RelatedData);
